module.exports = __webpack_public_path__ + "static/img/14.73a72c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/14.jpg
// module id = GNRl
// module chunks = 21